module.exports = __webpack_public_path__ + "static/logo-02@2x.3e1cc151.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/company_images/logo-02@2x.png
// module id = 828
// module chunks = 168707334958949